import PageId from "./PageId";
import { RouteStaticData } from "./Types";

// Single source of truth for each private route's staticData. The route files
// under `src/routes/_private` bind these objects into their `staticData`
// option (section routes share one object between their `index.tsx` and
// `$.tsx` files), and `navManifest.ts` reads the same objects so the sidebar
// and the route guard answer for the same registry nav id.
export const ROUTE_STATIC = {
  administration: {
    pageId: PageId.ADMINISTRATION,
    titleKey: "pageTitles.administration",
    navId: "administration",
  },
  meqLiveAdmin: {
    pageId: PageId.MEQ_LIVE_ADMIN,
    titleKey: "pageTitles.meqLiveAdmin",
    navId: "meq-live-admin",
  },
  gmpLambDataAnalysis: {
    pageId: PageId.GMP_LAMB_DATA_ANALYSIS,
    titleKey: "pageTitles.gmpLambDataAnalysis",
    navId: "gmp-lamb-data-analysis",
  },
  gmpLambBookings: {
    pageId: PageId.GMP_LAMB_BOOKINGS,
    titleKey: "pageTitles.gmpLambBooking",
    navId: "gmp-lamb-bookings",
  },
  gmpUpload: {
    pageId: PageId.GMP_UPLOAD,
    titleKey: "pageTitles.gmpUpload",
    navId: "gmp-upload",
  },
  dataAnalysisOverview: {
    pageId: PageId.DATA_ANALYSIS_OVERVIEW,
    titleKey: "pageTitles.meqDataAnalytics",
    navId: "data-analysis-overview",
  },
  meqLive: {
    pageId: PageId.MEQ_LIVE,
    titleKey: "pageTitles.meqLive",
    navId: "meq-live",
  },
  meqProbe: {
    pageId: PageId.MEQ_PROBE,
    titleKey: "pageTitles.meqProbe",
    navId: "meq-probe",
  },
  meqCamera: {
    pageId: PageId.MEQ_CAMERA,
    titleKey: "pageTitles.meqCamera",
    navId: "meq-camera",
  },
  meqLiveGenetics: {
    pageId: PageId.MEQ_LIVE_GENETICS,
    titleKey: "pageTitles.meqLiveGenetics",
    navId: "meq-live-genetics",
  },
  usdaAudit: {
    pageId: PageId.USDA_AUDIT,
    titleKey: "pageTitles.usdaAudit",
    navId: "usda-audit",
  },
  usdaAuditFeedback: {
    pageId: PageId.USDA_AUDIT_FEEDBACK,
    titleKey: "pageTitles.usdaAuditFeedback",
    navId: "usda-audit-feedback",
  },
  recordLabellingAdmin: {
    pageId: PageId.RECORD_LABELLING,
    titleKey: "pageTitles.recordLabelling",
    navId: "record-labelling-admin",
  },
  myAssignments: {
    pageId: PageId.MY_ASSIGNMENTS,
    titleKey: "pageTitles.myAssignments",
    navId: "my-assignments",
  },
  usdaImageCalibration: {
    pageId: PageId.USDA_CALIBRATION,
    titleKey: "pageTitles.usdaImageCalibration",
    navId: "usda-image-calibration",
  },
  management: {
    pageId: PageId.MANAGEMENT,
    titleKey: "pageTitles.management",
    navId: "management",
  },
  main: {
    pageId: PageId.MAIN_ENTRY,
    titleKey: "pageTitles.working",
    hideTitle: true,
  },
  noPackages: {
    pageId: PageId.NO_PKGS,
    titleKey: "pageTitles.noPackages",
    hideTitle: true,
  },
} as const satisfies Record<string, RouteStaticData>;
